import { DrawerActionTypes } from "./drawer.types";

export const toggleDrawerHidden = () => ({
  type: DrawerActionTypes.SHOW_DRAWER,
});
